import type { ToastData } from './types';

type Listener = (toasts: readonly ToastData[]) => void;

let counter = 0;
let toasts: ToastData[] = [];
const listeners = new Set<Listener>();

function emit() {
  const snapshot = [...toasts] as const;
  listeners.forEach((listener) => listener(snapshot));
}

export function generateId(): string {
  counter += 1;
  return `toast-${counter}`;
}

export function addToast(data: ToastData): void {
  toasts = [...toasts, data];
  emit();
}

export function updateToast(id: string, updates: Partial<ToastData>): void {
  toasts = toasts.map((t) => (t.id === id ? { ...t, ...updates } : t));
  emit();
}

export function dismissToast(id?: string): void {
  if (id === undefined) {
    toasts = [];
  } else {
    toasts = toasts.filter((t) => t.id !== id);
  }
  emit();
}

export function getSnapshot(): readonly ToastData[] {
  return toasts;
}

export function subscribe(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
